import { render, staticRenderFns } from "./dynamicTabs.vue?vue&type=template&id=442452ee&scoped=true&"
import script from "./dynamicTabs.vue?vue&type=script&lang=js&"
export * from "./dynamicTabs.vue?vue&type=script&lang=js&"
import style0 from "./dynamicTabs.vue?vue&type=style&index=0&id=442452ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442452ee",
  null
  
)

export default component.exports